import { inherits as _inherits, classCallCheck as _classCallCheck, createSuper as _createSuper } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { CachedDOMMeasurement as CachedDOMMeasurement$1 } from './CachedDOMMeasurement.js';

/** Measures the total external width of an element, including margin. */

var CachedTotalWidth = /*#__PURE__*/function (_CachedDOMMeasurement) {
  _inherits(CachedTotalWidth, _CachedDOMMeasurement);

  var _super = _createSuper(CachedTotalWidth);

  function CachedTotalWidth() {
    var _this;

    _classCallCheck(this, CachedTotalWidth);

    _this = _super.apply(this, arguments);
    _this.cssProperties = ['margin-left', 'margin-right'];
    _this.offsetProperties = ['offsetWidth'];
    return _this;
  }

  return CachedTotalWidth;
}(CachedDOMMeasurement$1);

export { CachedTotalWidth };
